import { useContext } from 'react';
import useHttp from './useHttp';
import AuthContext from '../context/authContext';

const useCall = () => {
  const authCtx = useContext(AuthContext);
  const { isLoading, error, sendRequest } = useHttp();

  const initiateCallback = async (callId, agentId) => {
    return new Promise(async (resolve, reject) => {
      const responseData = await sendRequest({
        url: '/api/v1/call/' + callId + '/callbacknow',
        method: 'POST',
        headers: authCtx.getAuthHeaders(),
        body: { agentId },
      });

      resolve(responseData);
    });
  };

  const initiateDial = async ({ agentId, destination, bookingId, skillId }) => {
    const responseData = await sendRequest({
      url: '/api/v1/call/dial',
      method: 'POST',
      headers: authCtx.getAuthHeaders(),
      body: { agentId, destination, bookingId, skillId },
    });
    return responseData;
  };

  const getOpenCallbacks = async (agentId = null) => {
    try {
      let url = '/api/v1/call';
      if (agentId) {
        url += `?agentId=${agentId}`;
      }

      const responseData = await sendRequest({
        url: url,
        method: 'GET',
        headers: authCtx.getAuthHeaders(),
      });
      return responseData;
    } catch (err) {
      console.error('error in useCall getOpenCallbacks:', err);
      return [];
    }
  };

  const getAvailableAgents = async () => {
    try {
      const responseData = await sendRequest({
        url: '/api/v1/call/available-agents',
        method: 'GET',
        headers: authCtx.getAuthHeaders(),
      });
      return responseData;
    } catch (err) {
      console.error('error in useCall getAvailableAgents:', err);
      return { agents: [], total: 0 };
    }
  };

  const getCallCount = async (skillIds = null) => {
    try {
      let url = '/api/v1/call/count';
      if (skillIds && skillIds.length > 0) {
        const skillIdsParam = skillIds.join(',');
        url += `?skillIds=${skillIdsParam}`;
      }

      const responseData = await sendRequest({
        url: url,
        method: 'GET',
        headers: authCtx.getAuthHeaders(),
        // Badge traffic: never drives the top request-activity bar.
        background: true,
      });
      return responseData.count || 0;
    } catch (err) {
      console.error('error in useCall getCallCount:', err);
      return 0;
    }
  };

  const deleteCall = async (callId, deletedReason) => {
    try {
      const responseData = await sendRequest({
        url: '/api/v1/call/' + callId,
        method: 'DELETE',
        headers: authCtx.getAuthHeaders(),
        body: { deletedReason },
      });

      return responseData;
    } catch (err) {
      console.error('error in useCall deleteCall:', err);
      throw err;
    }
  };

  return {
    isLoading,
    error,
    initiateCallback,
    initiateDial,
    getOpenCallbacks,
    getAvailableAgents,
    getCallCount,
    deleteCall,
  };
};

export default useCall;
